import React from "react";
import { Link } from "react-router-dom";

/**
 * Shared layout for legal/policy pages. Provides consistent styling so
 * Terms / Privacy / Refund pages all look the same.
 *
 * NOTE FOR OPERATORS:
 *   These pages are good-faith boilerplate suitable for soft-launch use,
 *   NOT legally audited text. Before scaling, have a UK solicitor or a
 *   service like Termly review them for your specific risk profile.
 */
export const LegalLayout = ({ title, subtitle, lastUpdated, children }) => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20">
      <span className="text-xs uppercase tracking-[0.3em] text-primary-yellow font-bold">Legal</span>
      <h1 className="font-heading text-4xl sm:text-5xl uppercase font-black mt-3 leading-none">{title}</h1>
      {subtitle && <p className="text-white/60 mt-3 max-w-2xl">{subtitle}</p>}
      {lastUpdated && (
        <p className="text-[10px] uppercase tracking-[0.25em] text-white/30 mt-6 font-mono-num">
          Last updated · {lastUpdated}
        </p>
      )}
      <div className="mt-10 prose-pitchiq">{children}</div>

      {/* Cross-links between legal pages */}
      <div className="mt-16 pt-8 border-t border-white/10 flex flex-wrap gap-x-6 gap-y-3 text-xs uppercase tracking-[0.2em] text-white/40">
        <Link to="/terms" className="hover:text-primary-yellow">Terms</Link>
        <Link to="/privacy" className="hover:text-primary-yellow">Privacy</Link>
        <Link to="/refund" className="hover:text-primary-yellow">Refund Policy</Link>
        <a href="mailto:info@pitchiq.win" className="hover:text-primary-yellow ml-auto">info@pitchiq.win</a>
      </div>
    </div>
  );
};

export const Section = ({ id, title, children }) => (
  <section id={id} className="mt-10 first:mt-0">
    <h2 className="font-heading text-xl sm:text-2xl uppercase font-black mb-3">{title}</h2>
    <div className="text-white/70 text-[15px] leading-relaxed space-y-3">{children}</div>
  </section>
);
